export default __webpack_public_path__ + "static/media/offc-mob2.95a0f383.png";